import axiosInstance from "../config/API";

const API_ENDPOINT = "/collection.php";

// Fetch collections, customers, areas, and plans
export const fetchCollectionsApi = async (filters = {}) => {
  const payload = { 
    search_text: filters.search_text || "",
    from_date: filters.from_date || "",
    to_date: filters.to_date || "",
    area_id: filters.area_id || "",
    staff_id: filters.staff_id || ""
  };
  
  const response = await axiosInstance.post(API_ENDPOINT, payload);
  console.log("fetch collections:", response.data);
  return response.data.body || { collection: [], customer: [], area: [], plan: [] };
};

// Add a new collection
export const addCollectionApi = async (collectionData) => {
  const payload = {
    collection_paid_date: collectionData.collection_paid_date,
    area_id: collectionData.area_id,
    customer_id: collectionData.customer_id,
    box_no: collectionData.box_no,
    plan_id: collectionData.plan_id,
    entry_amount: collectionData.entry_amount,
    payment_method: collectionData.payment_method,
    staff_id: collectionData.staff_id,
    current_user_id: collectionData.current_user_id,
    total_pending_amount: collectionData.total_pending_amount,
    balance_amount: collectionData.balance_amount,
  };
  const response = await axiosInstance.post(API_ENDPOINT, payload);
  console.log("add collection:", response.data);
  return response.data;
};

// Update a collection
export const updateCollectionApi = async (collectionData) => {
  const payload = {
    collection_paid_date: collectionData.collection_paid_date,
    area_id: collectionData.area_id,
    customer_id: collectionData.customer_id,
    box_no: collectionData.box_no,
    plan_id: collectionData.plan_id,
    entry_amount: collectionData.entry_amount,
    payment_method: collectionData.payment_method,
    staff_id: collectionData.staff_id,
    current_user_id: collectionData.current_user_id,
    edit_collection_id: collectionData.collection_id,
    total_pending_amount: collectionData.total_pending_amount,
    balance_amount: collectionData.balance_amount,
  };
  const response = await axiosInstance.post(API_ENDPOINT, payload);
  console.log("update collection:", response.data);
  return response.data;
};

// Delete a collection
export const deleteCollectionApi = async (collectionId, currentUserId) => {
  const payload = {
    delete_collection_id: collectionId,
    current_user_id: currentUserId,
  };
  const response = await axiosInstance.post(API_ENDPOINT, payload);
  console.log("delete collection:", response.data);
  return response.data;
};
